import { render, staticRenderFns } from "./NumberFieldFactor.vue?vue&type=template&id=34a0ef4b"
import script from "./NumberFieldFactor.vue?vue&type=script&lang=ts"
export * from "./NumberFieldFactor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports